import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuthenticationStatus } from "@nhost/react";
import { nhost } from "./utils/nhost";

function ManagerRoute({ component: Component, ...restOfProps }) {
  const { isAuthenticated, isLoading } = useAuthenticationStatus()
  const user = nhost.auth.getUser()

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isLoading ?
        <div className="text-center">
        <div
        className='spinner-border spinner-border-sm mt-90 ml-auto mr-auto'
        role='status'
        aria-hidden='true'
      ></div>
      </div>
      : 
      isAuthenticated&&user&&user.defaultRole==="editor" ? 
      <Component {...props} /> 
      : 
      <Redirect to="/login" />
      }
    />
  );
}

export default ManagerRoute;